import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/messageDetail';

/**
 * メッセージ一覧のState型
 */
export interface IMessageDetailState {
	readonly onesName: string;
	readonly messages: Actions.IMessage[];
}

/**
 * メッセージ一覧のState初期値
 */
const initialState: IMessageDetailState = {
	messages: [],
	onesName: '',
};

/**
 * メッセージ一覧用reducer
 * @param state State
 * @param action アクション
 */
const messageDetails = (state: IMessageDetailState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setOnesName)) {
		return {
			...state,
			onesName: action.payload.onesName,
		};
	}

	if (isType(action, Actions.setMessageList)) {
		return {
			...state,
			messages: action.payload.messages,
		};
	}

	if (isType(action, Actions.clearMessageList)) {
		return initialState;
	}

	return state;
};

export default messageDetails;



// WEBPACK FOOTER //
// ./src/reducers/MessageDetail.ts